import deCountries from '../../messages/countries/de.json';
import enCountries from '../../messages/countries/en.json';
import frCountries from '../../messages/countries/fr.json';
import esCountries from '../../messages/countries/es.json';
import ptCountries from '../../messages/countries/pt.json';
import { LocaleCode } from '@/i18n/locales';
import { Country as CscCountry } from 'country-state-city';

export interface Country {
  label: string;
  value: string;
}

export interface CountryList {
  [key: string]: string;
}

export type LocaleCountryList = {
  [L in LocaleCode]: CountryList;
};

const localCountries: LocaleCountryList = {
  de: deCountries,
  en: enCountries,
  fr: frCountries,
  es: esCountries,
  pt: ptCountries,
};

export const getCountryName = (locale: LocaleCode, isoCode: string): string | null => {
  const key = isoCode.trim().toUpperCase();

  return localCountries[locale]?.[key] ?? localCountries['en'][key] ?? null;
};

export const getCountryList = (locale: LocaleCode): Country[] => {
  const defaultCountries = localCountries['en'];
  const countries = CscCountry.getAllCountries();
  return countries
    .map((c) => {
      const key = c.isoCode;
      const label =
        (locale && localCountries[locale] && localCountries[locale][key]) ||
        defaultCountries[key] ||
        c.name;
      return { label, value: key };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};
